export default "__VITE_ASSET__cddfdc5c__"